import { ChakraProvider, Box } from "@chakra-ui/react";
import Content from "./Pages/Content";
import Event from "./Pages/Event";
import "@fontsource/poppins";
import "@fontsource/lexend";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./assets/styles/main.scss";
import FeaturedEvents from "./Pages/FeaturedEvents";
import MccResizeObserver from "./Components/MccResizeObserver";
import { mccTheme } from "./theme";

// Main page to route between sub-pages. Defaults with content page.
export const Main = () => (
  <ChakraProvider theme={mccTheme}>
    <Box>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <MccResizeObserver
                frameId="mcc-library-events-list"
                element={<Content />}
              />
            }
          />
          <Route
            path="/event"
            element={
              <MccResizeObserver
                frameId="mcc-library-event-page"
                element={<Event />}
              />
            }
          />
          <Route path="/featured-events" element={<FeaturedEvents />} />
          <Route
            path="/school-holidays-events"
            element={
              <MccResizeObserver
                frameId="mcc-library-school-holidays-events-list"
                element={<Content productTypeId="1184" />}
              />
            }
          />
          <Route
            path="/summer-reading"
            element={
              <MccResizeObserver
                frameId="mcc-library-summer-reading-events-list"
                element={<Content productTypeId="1211" />}
              />
            }
          />
          <Route
            path="/author-talks-events"
            element={
              <MccResizeObserver
                frameId="mcc-library-author-talks-events-list"
                element={<Content productTypeId="1187" />}
              />
            }
          />
        </Routes>
      </Router>
    </Box>
  </ChakraProvider>
);
